"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _apiClient = _interopRequireDefault(require("hub-http/clients/apiClient"));

var API_BASE = 'app-workspaces/v1/payloads';

var PayloadAPI =
/*#__PURE__*/
function () {
  function PayloadAPI() {
    (0, _classCallCheck2.default)(this, PayloadAPI);
  }

  (0, _createClass2.default)(PayloadAPI, null, [{
    key: "getPayload",
    value: function getPayload() {
      return _apiClient.default.get(API_BASE);
    }
  }]);
  return PayloadAPI;
}();

exports.default = PayloadAPI;
module.exports = exports.default;